import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import the styles
import styles from './SectorsSlider.module.css';
import Footer from '../Footer/Footer_ar'
import BottomButton from '../Footer/BottomButton'
import debounce from 'lodash/debounce'; // Import debounce function

const SectorsSlider_ar = () => {
  const sectors = [
    'Manufacturing',
    'Trading',
    'Tech',
    'Transportation',
    'Construction',
  ];
  const [selectedPage, setSelectedPage] = useState(0);
  const footerIconsRef = useRef(null);
  const location = useLocation();
  const [showBottomButton, setShowBottomButton] = useState(true); // State to manage button visibility
  useEffect(() => {
    // Parse the 'pagenumb' query parameter from the URL
    const params = new URLSearchParams(location.search);
    const pageNumber = parseInt(params.get('pagenumb'), 10) || 0;

    // Update the selectedPage state based on the parsed value
    setSelectedPage(Math.max(0, Math.min(pageNumber - 1, sectors.length - 1)));
  }, [location.search, sectors.length]);
  useEffect(() => {
    const handleScroll = debounce((event) => {
      if (event.deltaY > 0) {
        // Scrolling down, go to the next page
        setSelectedPage((prevPage) => (prevPage === sectors.length - 1 ? 0 : prevPage + 1));
      } else if (event.deltaY < 0) {
        // Scrolling up, go to the previous page
        setSelectedPage((prevPage) => (prevPage === 0 ? sectors.length - 1 : prevPage - 1));

      }
    }, 200); // Adjust the debounce delay as needed

    // Add the event listener to handle scroll events
    window.addEventListener('wheel', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, [selectedPage]);

  useEffect(() => {
    const footerIcons = document.getElementById('footericons');
    const observer = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: 0.1,
    });
    if (footerIcons) {
      observer.observe(footerIcons);
    }

    return () => {
      if (footerIcons) {
        observer.unobserve(footerIcons);
      }
    };
  }, []);

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        setShowBottomButton(true); // If intersecting, show the button
      } else {
        setShowBottomButton(false); // If not intersecting, hide the button
      }
    });
  };

  const handlePageChange = (index) => {
    setSelectedPage(index);
  };
  const renderCustomArrow = (direction, clickHandler, isEnabled, label) => (
    <div className={styles.arrowsContainer} style={{ margin: '92vh 0% 0% 5vw' }}>
      {direction === 'prev' && (
        <button
          className={styles.leftarrow}
          onClick={() => {
            clickHandler();
            setSelectedPage((prevPage) => (prevPage === sectors.length - 1 ? 0 : prevPage + 1));
          }}
          disabled={!isEnabled}
          aria-label={label}
        ></button>
      )}
      {/* Numbered buttons */}
      {direction !== 'prev' && (
        <div className={styles.arrows} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          {sectors.map((_, index) => (
            <button
              style={{ fontFamily: 'Cairo Light', lineHeight: '10%' }}
              key={index}
              className={`${styles.pageNumber} ${index === selectedPage ? styles.selectedPage : ''}`}
              onClick={() => setSelectedPage(index)}
            >
              {(index + 1).toLocaleString('ar-EG')}
            </button>
          ))}
        </div>
      )}
      {direction === 'next' && (
        <button
          className={styles.rightarrow}
          onClick={() => {
            clickHandler();
            setSelectedPage((prevPage) => (prevPage === 0 ? sectors.length - 1 : prevPage - 1));

          }}
          disabled={!isEnabled}
          aria-label={label}
        ></button>
      )}
    </div>
  );

  const [positions, setPositions] = useState([0, 0, 0, 0, 0]);
  // const [prevClicked, setPrevClicked] = useState([0, 0, 0, 0]);
  const [touchStartX, setTouchStartX] = useState(0);

  // const handleImageClick = (index, imgIndex) => {
  //   const newPositions = [...positions];
  //   const newPrevClicked = [...prevClicked];

  //   if (index === 1 && prevClicked[imgIndex] !== 1) {
  //     newPositions[imgIndex] += 55; // Slide to the right
  //   } else if (index === 3 && prevClicked[imgIndex] !== 3) {
  //     newPositions[imgIndex] -= 55; // Slide to the left
  //   } else if (index === 2 && prevClicked[imgIndex] === 3) {
  //     newPositions[imgIndex] += 55; // Slide to the left
  //   } else if (index === 2 && prevClicked[imgIndex] === 1) {
  //     newPositions[imgIndex] -= 55; // Slide to the right
  //   }
  //   newPrevClicked[imgIndex] = index;

  //   setPositions(newPositions);
  //   setPrevClicked(newPrevClicked);
  // };
  const handleTouchStart = (event) => {
    setTouchStartX(event.touches[0].clientX);
  };
  const handleTouchMove = (event, imgIndex) => {
    const touchMoveX = event.touches[0].clientX;
    const diffX = touchMoveX - touchStartX;

    // Determine if swiping should be prevented
    const isFirstImage = positions[imgIndex] === 0;
    const isLastImage = positions[imgIndex] <= -110; // Adjust this value as per your image width and count

    const newPositions = [...positions];
    const threshold = 50;

    if (Math.abs(diffX) > threshold && !(isFirstImage && diffX > 0) && !(isLastImage && diffX < 0)) {
      newPositions[imgIndex] += diffX > 0 ? 55 : -55; // Adjust position based on the direction of the swipe
      setPositions(newPositions);
      setTouchStartX(touchMoveX);
    }
  };


  return (
    <div>
      <div className={styles.mobPageContainer} style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '100vh', backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
        <div className={styles.submobPageContainer}>
          <div className={styles.mobTitle2}>
            <h1>
              القطاعات<span style={{ color: '#EBD5A8' }}>&nbsp;التي نخدمها</span>
            </h1>
          </div>
          <div>
            <div style={{ height: '35vw', overflow: 'hidden' }}>
              <div className={styles.imagesCont} style={{ display: 'flex', flexDirection: 'row', transform: `translateX(${positions[0]}vw)`, transition: 'transform 0.9s ease ' }} onTouchStart={handleTouchStart} onTouchMove={(event) => handleTouchMove(event, 0)}>
                <img src="/Sectors/Factory pic 1.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Factory pic 2.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Factory pic 3.png" alt="" style={{ width: '50vw' }} />
              </div>

            </div>

            <div className={styles.mobText}>
              <h2 className={styles.mobHead12}>دعم بنكنوت </h2>
              <h2 className={styles.mobHead22}>للمصانع</h2>
              <div className={styles.mobDisCont2}><p>استشاراتنا متخصصة في تمكين المصانع من خلال تحليل تكاليف دقيق وتخصيص رأس المال استراتيجي</p></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', marginBottom: '15%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Animal feeds.svg" alt="" />
                  <h1>صناعة
                    الأعلاف الحيوانية </h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Clothes.svg" alt="" />
                  <h1>تجارة
                    الأقمشة والملابس </h1>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Pottle.svg" alt="" />
                  <h1>تجارة
                    البلاستيك </h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Food.svg" alt="" />
                  <h1>تجارة
                    المنتجات الغذائية </h1>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Medical.svg" alt="" />
                  <h1>تجارة
                    اللوازم الطبية</h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Wood.svg" alt="" />
                  <h1>تجارة
                    الأخشاب </h1>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div style={{ height: '35vw', overflow: 'hidden' }}>
              <div className={styles.imagesCont} style={{ display: 'flex', flexDirection: 'row', transform: `translateX(${positions[1]}vw)`, transition: 'transform 0.9s ease ' }} onTouchStart={handleTouchStart} onTouchMove={(event) => handleTouchMove(event, 1)}>
                <img src="/Sectors/Trading pic 1.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Trading pic 2.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Trading pic 3.png" alt="" style={{ width: '50vw' }} />
              </div></div>
            <div className={styles.mobText}>
              <h2 className={styles.mobHead12}>دعم بنكنوت </h2>
              <h2 className={styles.mobHead22}>للتجارة</h2>
              <div className={styles.mobDisCont2}><p>نمكن التجار من خلال تحسين عمليات الدفع، وإدارة الأمور المالية، وتقليل المخاطر</p></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', marginBottom: '15%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Animal feeds.svg" alt="" />
                  <h1>صناعة
                    الأعلاف الحيوانية </h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Clothes.svg" alt="" />
                  <h1>تجارة
                    الأقمشة والملابس </h1>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Pottle.svg" alt="" />
                  <h1>تجارة
                    البلاستيك </h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Food.svg" alt="" />
                  <h1>تجارة المنتجات الغذائية </h1>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Medical.svg" alt="" />
                  <h1>تجارة
                    اللوازم الطبية</h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Wood.svg" alt="" />
                  <h1>تجارة
                    الأخشاب </h1>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ height: '35vw', overflow: 'hidden' }}>
              <div className={styles.imagesCont} style={{ display: 'flex', flexDirection: 'row', transform: `translateX(${positions[2]}vw)`, transition: 'transform 0.9s ease ' }} onTouchStart={handleTouchStart} onTouchMove={(event) => handleTouchMove(event, 2)}>
                <img src="/Sectors/tech pic 1.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/tech pic 2.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/tech pic 3.png" alt="" style={{ width: '50vw' }} />
              </div></div>

            <div className={styles.mobText}>
              <h2 className={styles.mobHead12}>دعم بنكنوت </h2>
              <h2 className={styles.mobHead22}>للتكنولوجيا</h2>
              <div className={styles.mobDisCont2}><p>نساعد الشركات التكنولوجية من خلال وضع استراتيجيات للنمو المالي، وتأمين رأس المال، وإدارة المخاطر</p></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', marginBottom: '15%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/software.svg" alt="" />
                  <h1>شركة برمجيات</h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/product.svg" alt="" />
                  <h1>شركات تعتمد على المنتجات</h1>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/hardware.svg" alt="" />
                  <h1>توريدات الأجهزة </h1>
                </div>

              </div>

            </div>
          </div>
          <div>
            <div style={{ height: '35vw', overflow: 'hidden' }}>
              <div className={styles.imagesCont} style={{ display: 'flex', flexDirection: 'row', transform: `translateX(${positions[3]}vw)`, transition: 'transform 0.9s ease ' }} onTouchStart={handleTouchStart} onTouchMove={(event) => handleTouchMove(event, 3)}>
                <img src="/Sectors/Transportation pic 1.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Transportation pic 2.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Transportation pic 3.png" alt="" style={{ width: '50vw' }} />
              </div></div>

            <div className={styles.mobText}>
              <h2 className={styles.mobHead12}>دعم بنكنوت </h2>
              <h2 className={styles.mobHead22}>لقطاع
                النقل</h2>
              <div className={styles.mobDisCont2}><p>سواء كان مجال عملك  في اللوجستيات، الشحن، أو أي جانب آخر من قطاع النقل، نقدم مجموعة من الخدمات المهنية لدعم احتياجاتك</p></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', marginBottom: '15%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/shipment.svg" alt="" />
                  <h1>شركات اللوجستيات</h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/logistics.svg" alt="" />
                  <h1>شركات الشحن والتوصيل</h1>
                </div>
              </div>


            </div>
          </div>
          <div>
            <div style={{ height: '35vw', overflow: 'hidden' }}>
              <div className={styles.imagesCont} style={{ display: 'flex', flexDirection: 'row', transform: `translateX(${positions[4]}vw)`, transition: 'transform 0.9s ease ' }} onTouchStart={handleTouchStart} onTouchMove={(event) => handleTouchMove(event, 4)}>
                <img src="/Sectors/Construction pic 1.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Construction pic 2.png" alt="" style={{ width: '50vw' }} />
                <img src="/Sectors/Construction pic 3.png" alt="" style={{ width: '50vw' }} />
              </div></div>

            <div className={styles.mobText}>
              <h2 className={styles.mobHead12}>دعم بنكنوت </h2>
              <h2 className={styles.mobHead22}> لقطاع
                الانشائات</h2>
              <div className={styles.mobDisCont2}><p>سواء كان مجال عملك  في اللوجستيات، الشحن، أو أي جانب آخر من قطاع النقل، نقدم مجموعة من الخدمات المهنية لدعم احتياجاتك</p></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', marginBottom: '15%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Constructions.svg" alt="" />
                  <h1>شركات الإنشاءات</h1>
                </div>
                <div className={styles.iconsCont23} style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src="/Engineering.svg" alt="" />
                  <h1>شركات الاستشارات الهندسية</h1>
                </div>
              </div>


            </div>
          </div>
        </div>
        <Footer></Footer>
        {showBottomButton && <BottomButton ref={footerIconsRef}></BottomButton>}
      </div>

      <div className={styles.pageContainer}>
        {/* Carousel */}
        <Carousel
          selectedItem={selectedPage}

          showThumbs={false}
          showStatus={false}
          infiniteLoop={true}
          showIndicators={false}
          showArrows={true} // Enable arrows
          renderArrowNext={(clickHandler1, hasNext, label) =>
            renderCustomArrow('next', clickHandler1, hasNext, label)
          }
          renderArrowPrev={(clickHandler2, hasPrev, label) =>
            renderCustomArrow('prev', clickHandler2, hasPrev, label)
          }

        >
          {sectors.map((sector, index) => (
            <div className={styles.CarouselCont} key={index} style={{ position: 'relative' }}>
              {/* Different Arrangement for Each Slide */}
              {index === 0 && (
                <>
                  {/* Background Image for Manufacturing */}
                  <img
                    src={`/Manufactoring\ background.png`}
                    className={styles.backgroundImage}
                  />
                  {/* Overlay for Manufacturing */}
                  <div className='overlay'>

                    <div className={styles.slidecontainer} style={{ flexDirection: 'row-reverse' }}>

                      <div className={styles.leftCont} style={{ marginLeft: "0%", marginRight: '15%' }}>

                        <div className={styles.lefttopCont}>
                          <div className={styles.headline}  >
                            <h1 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>تمويل بنكنوت المالي  </h1>
                            <h2 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>للمصانع</h2>

                          </div>

                          <div className={styles.des1}>
                            <p style={{ textAlign: 'right', width: '100%', marginTop: '22px', fontFamily: 'Cairo Light' }}>لدينا استشارات متخصصة في تمكين المصانع من خلال تحليل دقيق للتكاليف وتخصيص رأس المال الاستراتيجي  </p>
                          </div>
                        </div>
                        <div className={styles.leftbottomCont}>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Animal\ feeds.svg`} alt="Animal Feeds" />
                              <p>صناعة
                                الأعلاف الحيوانية </p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Clothes.svg`} alt="Fabrics & Clothes" />
                              <p>تجارة
                                الأقمشة والملابس </p>
                            </div>
                          </div>

                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Pottle.svg`} alt="Plastics" />
                              <p>تجارة البلاستيك</p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Food.svg`} alt="Food Products" />
                              <p>تجارة
                                المنتجات الغذائية </p>
                            </div>
                          </div>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Medical.svg`} alt="Medical Supplies" />
                              <p>تجارة
                                اللوازم الطبية</p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Wood.svg`} alt="Woods" />
                              <p>تجارة
                                الأخشاب </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.rightCont} style={{ marginRight: '5%', marginLeft: '1.5rem' }}>
                        <div className={styles.righttopCont}>
                          <img src="/sectors_slide1.png" alt="Sectors Image" />
                        </div>
                        <div className={styles.rightbottomCont}>
                          <div className={styles.des22}>
                            <p>
                              من تأمين التمويل إلى إدارة المخاطر، خبرتنا تدعم اتخاذ القرارات المستنيرة لتحقيق النمو المستدام وزيادة الربحية.
                            </p></div>
                        </div>
                      </div>

                    </div>




                  </div>
                  {/* Content of the Slide */}


                </>
              )}

              {index === 1 && (
                <>
                  {/* Background Image for Trading */}
                  <img
                    src={`/Trading\ background.png`}
                    className={styles.backgroundImage}
                  />
                  {/* Overlay for Trading */}
                  <div className='overlay'>

                    <div className={styles.slidecontainer} style={{ flexDirection: 'row-reverse' }}>

                      <div className={styles.leftCont} style={{ marginLeft: "0%", marginRight: '15%' }}>

                        <div className={styles.lefttopCont}>
                          <div className={styles.headline} style={{ fontSize: '56px', lineHeight: '120%' }}>
                            <h1 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>تمويل بنكنوت المالي   </h1>
                            <h2 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>للتجارة</h2>

                          </div>

                          <div className={styles.des1}>
                            <p style={{ textAlign: 'right', width: '100%', marginTop: '22px', fontFamily: 'Cairo Light' }}>نمكن التجار من خلال تحسين عمليات الدفع، وإدارة الأمور المالية، وتقليل المخاطر.</p>
                          </div>
                        </div>
                        <div className={styles.leftbottomCont}>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Animal\ feeds.svg`} alt="Animal Feeds" />
                              <p>صناعة
                                الأعلاف الحيوانية </p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Clothes.svg`} alt="Fabrics & Clothes" />
                              <p>تجارة
                                الأقمشة والملابس </p>
                            </div>
                          </div>

                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Pottle.svg`} alt="Plastics" />
                              <p>تجارة البلاستيك</p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Food.svg`} alt="Food Products" />
                              <p>تجارة
                                المنتجات الغذائية </p>
                            </div>
                          </div>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Medical.svg`} alt="Medical Supplies" />
                              <p>تجارة
                                اللوازم الطبية</p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/Wood.svg`} alt="Woods" />
                              <p>تجارة
                                الأخشاب </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.rightCont} style={{ marginRight: '5%', marginLeft: '1.5rem' }} >
                        <div className={styles.righttopCont}>
                          <img src="/sectors_slide2.png" alt="Sectors Image" />
                        </div>
                        <div className={styles.rightbottomCont}>
                          <div className={styles.des22}>
                            <p>
                              من إدارة المال إلى تمويل التوسع، تقود خبرتنا النمو مع ضمان الامتثال والتخطيط الاستراتيجي لضمان النجاح المستمر.
                            </p></div>
                        </div>
                      </div>

                    </div>

                  </div>


                </>
              )}

              {index === 2 && (
                <>
                  {/* Background Image for Tech */}
                  <img
                    src={`/Tech\ background.png`}
                    className={styles.backgroundImage}
                  />
                  {/* Overlay for Tech */}
                  <div className='overlay'>


                    <div className={styles.slidecontainer} style={{ flexDirection: 'row-reverse' }}>

                      <div className={styles.leftCont} style={{ marginLeft: "0%", marginRight: '15%' }}>

                        <div className={styles.lefttopCont}>
                          <div className={styles.headline} style={{ fontSize: '56px', lineHeight: '120%' }}>
                            <h1 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>دعم بنكنوت للتكنولوجيا</h1>
                            <h2 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}> والاتصالات</h2>

                          </div>


                          <div className={styles.des1}>
                            <p style={{ textAlign: 'right', width: '100%', marginTop: '22px', fontFamily: 'Cairo Light' }}>نساعد الشركات التكنولوجية من خلال وضع استراتيجيات للنمو المالي، وتأمين رأس المال، وإدارة المخاطر.</p>
                          </div>
                        </div>
                        <div className={styles.leftbottomCont}>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/software.svg`} alt="شركة برمجيات" />
                              <p>شركة برمجيات</p>
                            </div>
                          </div>
                          <div className={styles.iconsCont2}>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/product.svg`} alt="شركات تعتمد على المنتجات" />
                              <p>شركات تعتمد على المنتجات</p>
                            </div>
                            <div className={styles.icon2} style={{ alignSelf: 'end' }}>
                              <img src={`/hardware.svg`} alt="توريدات الأجهزة " />
                              <p>توريدات الأجهزة </p>
                            </div>
                            {/* <div className={styles.icon}>
    <img src={`/Food.svg`} alt="Food Products" />
     <p>تجارة
المنتجات الغذائية </p>
    </div> */}
                          </div>
                          {/* <div className={styles.iconsCont2}>
  <div className={styles.icon}>
    <img  src={`/Medical.svg`} alt="Medical Supplies" />
     <p>تجارة 
اللوازم الطبية</p>
    </div>
    <div className={styles.icon}>
    <img src={`/Wood.svg`} alt="Woods"/>
     <p>تجارة
الأخشاب </p>
    </div>
  </div> */}
                        </div>
                      </div>
                      <div className={styles.rightCont} style={{ marginRight: '5%', marginLeft: '1.5rem' }}>
                        <div className={styles.righttopCont}>
                          <img src="/sectors_slide3.png" alt="Sectors Image" />
                        </div>
                        <div className={styles.rightbottomCont}>
                          <div className={styles.des22}>
                            <p>
                              من إدارة المال إلى تمويل التوسع، تقود خبرتنا النمو مع ضمان الامتثال والتخطيط الاستراتيجي لضمان النجاح المستمر.                             </p></div>
                        </div>
                      </div>

                    </div>


                  </div>
                  {/* Content of the Slide */}



                </>
              )}

              {index === 3 && (
                <>
                  {/* Background Image for Transportation */}
                  <img
                    src={`/Transportation\ background.png`}
                    className={styles.backgroundImage}
                  />
                  {/* Overlay for Transportation */}
                  <div className='overlay'>

                    <div className={styles.slidecontainer} style={{ flexDirection: 'row-reverse' }}>

                      <div className={styles.leftCont} style={{ marginLeft: "0%", marginRight: '15%' }}>

                        <div className={styles.lefttopCont}>
                          <div className={styles.headline} style={{ fontSize: '56px', lineHeight: '120%' }}>
                            <h1 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>دعم بنكنوت لقطاع</h1>
                            <h2 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}> النقل</h2>



                          </div>

                          <div className={styles.des1}>
                            <p style={{ textAlign: 'right', width: '100%', marginTop: '22px', fontFamily: 'Cairo Light' }}> سواء كان مجال عملك  في اللوجستيات، الشحن، أو أي جانب آخر من قطاع النقل، نقدم مجموعة من الخدمات المهنية لدعم احتياجاتك</p>
                          </div>
                        </div>
                        <div className={styles.leftbottomCont}>
                          <div className={styles.iconsCont22}>
                            <div className={styles.icon2}>
                              <img src={`/logistics.svg`} alt="شركات اللوجستيات" />
                              <p>شركات اللوجستيات</p>
                            </div>
                            {/* <div className={styles.icon}>
                            <img  src={`/hardware.svg`} alt="Hardware supplies" />
                            <p>Hardware supplies</p>
                            </div> */}
                          </div>

                          <div className={styles.iconsCont22}>
                            <div className={styles.icon2}>
                              <img src={`/shipment.svg`} alt="شركات الشحن والتوصيل" />
                              <p>شركات الشحن والتوصيل</p>
                            </div>
                            {/* <div className={styles.icon}>
                            <img src={`/Food.svg`} alt="Food Products" />
                            <p>تجارة
المنتجات الغذائية </p>
                            </div> */}
                          </div>
                          {/* <div className={styles.iconsCont2}>
                              <div className={styles.icon}>
                                <img  src={`/Medical.svg`} alt="Medical Supplies" />
                                <p>تجارة 
اللوازم الطبية</p>
                                </div>
                                <div className={styles.icon}>
                                <img src={`/Wood.svg`} alt="Woods"/>
                                <p>تجارة
الأخشاب </p>
                                </div>
                              </div> */}
                        </div>
                      </div>
                      <div className={styles.rightCont} style={{ marginRight: '5%', marginLeft: '1.5rem' }}>
                        <div className={styles.righttopCont}>
                          <img src="/sectors_slide4.png" alt="Sectors Image" />
                        </div>
                        <div className={styles.rightbottomCont}>
                          <div className={styles.des22}>
                            <p>
                              من إدارة المال إلى تمويل التوسع، تقود خبرتنا النمو مع ضمان الامتثال والتخطيط الاستراتيجي لضمان النجاح المستمر.                             </p></div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* Content of the Slide */}

                </>
              )}

              {index === 4 && (
                <>
                  {/* Background Image for Construction */}
                  <img
                    src={`/Construction\ background.png`}
                    className={styles.backgroundImage}
                  />
                  {/* Overlay for Construction */}
                  <div className='overlay'>

                    <div className={styles.slidecontainer} style={{ flexDirection: 'row-reverse' }}>

                      <div className={styles.leftCont} style={{ marginLeft: "0%", marginRight: '15%' }}>

                        <div className={styles.lefttopCont}>
                          <div className={styles.headline} style={{ fontSize: '56px', lineHeight: '120%' }}>
                            <h1 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}>دعم بنكنوت لقطاع </h1>
                            <h2 style={{ fontSize: '56px', lineHeight: '120%', textAlign: 'right', fontFamily: 'Cairo Medium' }}> الإنشاءات</h2>

                          </div>

                          <div className={styles.des1}>
                            <p style={{ textAlign: 'right', width: '100%', marginTop: '22px', fontFamily: 'Cairo Light' }}> نتخصص في مساعدة مشاريع الإنشاءات من خلال التخطيط المالي وإدارة المخاطر، وتمويل المشاريع </p>
                          </div>
                        </div>
                        <div className={styles.leftbottomCont}>
                          <div className={styles.iconsCont22}>
                            <div className={styles.icon2}>
                              <img src={`/Constructions.svg`} alt="شركات الإنشاءات" />
                              <p>شركات الإنشاءات</p>
                            </div>
                            {/* <div className={styles.icon}>
    <img  src={`/hardware.svg`} alt="Hardware supplies" />
     <p>Hardware supplies</p>
    </div> */}
                          </div>

                          <div className={styles.iconsCont22}>
                            <div className={styles.icon2}>
                              <img src={`/Engineering.svg`} alt="شركات الاستشارات الهندسية" />
                              <p>شركات الاستشارات الهندسية</p>
                            </div>
                            {/* <div className={styles.icon}>
    <img src={`/Food.svg`} alt="Food Products" />
     <p>تجارة
المنتجات الغذائية </p>
    </div> */}
                          </div>
                          {/* <div className={styles.iconsCont2}>
  <div className={styles.icon}>
    <img  src={`/Medical.svg`} alt="Medical Supplies" />
     <p>تجارة 
اللوازم الطبية</p>
    </div>
    <div className={styles.icon}>
    <img src={`/Wood.svg`} alt="Woods"/>
     <p>تجارة
الأخشاب </p>
    </div>
  </div> */}
                        </div>
                      </div>
                      <div className={styles.rightCont} style={{ marginRight: '5%', marginLeft: '1.5rem' }}>
                        <div className={styles.righttopCont}>
                          <img src="/sectors_slide5.png" alt="Sectors Image" />
                        </div>
                        <div className={styles.rightbottomCont}>
                          <div className={styles.des22}>
                            <p>
                              خبرتنا تضمن السيطرة على التكاليف، وإدارة تدفق النقدية، والامتثال، مما يعزز تنفيذ المشاريع بنجاح ضمن الجداول الزمنية والميزانيات.  </p></div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* Content of the Slide */}


                </>
              )}
            </div>
          ))}

        </Carousel>

      </div>
    </div>
  );
};

export default SectorsSlider_ar;